import React from 'react';

interface WeeklyMagazineLogoProps {
  className?: string;
  size?: number;  
}

export const WeeklyMagazineLogo: React.FC<WeeklyMagazineLogoProps> = ({ size = 24, className = "" }) => {
  return (
    <div 
      className={`relative flex items-center justify-center overflow-hidden rounded-[30%] bg-[#1a1a1a] shadow-lg ${className}`} 
      style={{ width: size, height: size }}
    >
      {/* Premium Metallic Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#2c2c2c] via-[#1a1a1a] to-[#000000]" />
      
      {/* Decorative Accent Ring */}
      <div className="absolute inset-[10%] rounded-full border border-white/5" />
      
      {/* Abstract 'W' Typography Icon */}
      <svg 
        width="65%" 
        height="65%" 
        viewBox="0 0 24 24" 
        fill="none" 
        className="relative z-10"
      >
        <defs>
          <linearGradient id="logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fff" stopOpacity="1" />
            <stop offset="50%" stopColor="#e0e0e0" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#a0a0a0" stopOpacity="0.8" />
          </linearGradient>
        </defs>
        
        {/* Abstract Stylized W / Magazine Fold */}
        <path 
          d="M3 7L12 3L21 7V17L12 21L3 17V7Z" 
          stroke="url(#logo-grad)" 
          strokeWidth="1.5" 
          strokeLinejoin="round" 
        />
        <path 
          d="M12 3V21" 
          stroke="url(#logo-grad)" 
          strokeWidth="1" 
          strokeDasharray="1 2"
          strokeOpacity="0.5"
        />
        <path 
          d="M7 10L12 12L17 10" 
          stroke="url(#logo-grad)" 
          strokeWidth="2" 
          strokeLinecap="round" 
        />
        <path 
          d="M7 14L12 16L17 14" 
          stroke="url(#logo-grad)" 
          strokeWidth="2" 
          strokeLinecap="round" 
        />
      </svg>

      {/* Subtle Glow Overlay */}
      <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-white/5 blur-2xl rounded-full" />
    </div>
  );
};
